<mat-dialog-content></mat-dialog-content>
<mat-dialog-content>
  <app-acc-list [listTitle]="data.title??''" [myClass]="data.myClass??''" [list]="data.list" [withCheckbox]="data.withCheckbox??false"
    (listValue)="data.onChecksChange?data.onChecksChange($event):null"></app-acc-list>
</mat-dialog-content>
<mat-dialog-content>
  <div class="form-submit">
    <button (click)="onClose()" class="custom-button">Close</button>
  </div>
</mat-dialog-content>